import { Component, inject, input } from '@angular/core';
import { IonIcon } from "@ionic/angular/standalone";
import { ButtonComponent } from "../../../ui/form/button/button.component";
import { ModalService } from 'src/app/services/modal.service';

@Component({
  selector: 'app-rejection-notice',
  templateUrl: './rejection-notice.component.html',
  styleUrls: ['./rejection-notice.component.scss'],
  standalone: true,
  imports: [IonIcon, ButtonComponent]
})
export class RejectionNoticeComponent {
  modalService = inject(ModalService);

  modalId = input<string>();
  rejectionReason = input<string>();
}
